import React from 'react';
import './Stats.css';

const Stats = () => {
  const stats = [
    { number: '+400', label: 'empresas atendidas' },
    { number: '5,0 ★', label: 'no Google' },
    { number: '40', label: 'avaliações' },
    { number: 'R$30 mi', label: 'geridos' },
    { number: '17 anos', label: 'de metodologia' },
  ];

  return (
    <div className="stats">
      <div className="wrap stats-wrap">
        {stats.map((stat, index) => (
          <div key={index} className="stats-item">
            <span className="stats-number">{stat.number}</span>
            <span className="stats-label">{stat.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Stats;
